export default "__VITE_ASSET__072d2037__"